<template>
    <div class="group_tab-container" v-if="filterSelected">
        <div class="group" v-for="(tab, tab_index) in filterSelected" :key="tab_index">
            <div class="tab-panel">
                <div class="tab-content">
                    <b>{{tab.root_id}}</b>
                    <div class="tab-content_body">
                        <template v-for="tab_child in tab.child">
                            <div v-if="tab_child.value" class="tab-item" :key="tab_child.value.code">
                                {{tab_child.value.name}}
                            </div>
                            <div v-if="tab_child.min" class="tab-item" :key="tab_child.child_id">
                                {{tab_child.min}} - {{tab_child.max}}
                            </div>
                        </template>
                        <div class="tab-item">x {{tab.count}}</div>
                    </div>
                </div>
                <div class="controll">
                    <span>
                        <svg @click="deleteBlock(tab_index)" width="20px" height="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 512 512" style="fill: #6f6f6f" xml:space="preserve">
                        <g transform="translate(1 1)">
                            <g>
                                <g>
                                    <path d="M436.016,73.984c-99.979-99.979-262.075-99.979-362.033,0.002c-99.978,99.978-99.978,262.073,0.004,362.031
                                        c99.954,99.978,262.05,99.978,362.029-0.002C535.995,336.059,535.995,173.964,436.016,73.984z M405.848,405.844
                                        c-83.318,83.318-218.396,83.318-301.691,0.004c-83.318-83.299-83.318-218.377-0.002-301.693
                                        c83.297-83.317,218.375-83.317,301.691,0S489.162,322.549,405.848,405.844z"/>
                                    <path d="M360.592,149.408c-8.331-8.331-21.839-8.331-30.17,0l-75.425,75.425l-75.425-75.425c-8.331-8.331-21.839-8.331-30.17,0
                                        s-8.331,21.839,0,30.17l75.425,75.425L149.43,330.4c-8.331,8.331-8.331,21.839,0,30.17c8.331,8.331,21.839,8.331,30.17,0
                                        l75.397-75.397l75.419,75.419c8.331,8.331,21.839,8.331,30.17,0c8.331-8.331,8.331-21.839,0-30.17l-75.419-75.419l75.425-75.425
                                        C368.923,171.247,368.923,157.74,360.592,149.408z"/>
                                </g>
                            </g>
                        </g>
                        </svg>
                    </span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "FilterSelected",
        props: ['filterSelected'],
        data() {
            return {
                tabs: null
            }
        },
        methods: {
            deleteBlock(tab_index) {
                this.$emit('deleteBlock', tab_index)
            },
         },

    }
</script>

<style scoped>
    .tab-panel {
        background: #e0e5e8;
        padding: 10px 15px 10px 20px;
        margin-bottom: 10px;
        border-radius: 3px;
        display: flex;
        align-items: center;
    }

    .tab-panel b {
        font-size: 14px;
        text-transform: uppercase;
        padding: 0 10px 0 0;
        line-height: normal;
    }

    .tab-item {
        padding: 0 10px;
        border-radius: 4px;
        font-weight: bold;
        background: white;
    }

    .controll {
        display: flex;
        padding-left: 5px;
    }

    .tab-content {
        flex:1;
        display: flex;
        align-items: flex-start;
    }

    .tab-content_body {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 5px;
    }

    .controll span {
        display: flex;
        cursor: pointer;
    }

</style>